import Ajv from 'ajv';

const ajv = new Ajv({allErrors: true});

class JsonValidator {
  constructor() {
    this._validator = {};
  }

  addSchema(schemaName = '', schema) {
    if (typeof schemaName === 'string') {
      schemaName = schemaName.trim();
    }
    if (!schemaName) {
      throw new Error('invalid schema name');
    }
    this._validator[schemaName] = ajv.compile(schema);

    return this;
  }

  getValidator(schemaName) {
    return this._validator[schemaName];
  }

  validate(schemaName, schema) {
    let validator = this._validator[schemaName];
    validator(schema);
    let errors = validator.errors;
    if (!errors) {
      return null;
    }
    errors = errors.map(e => {
      let errProperty = e.dataPath ? `[${e.dataPath}] ` : '';
      return errProperty + e.message;
    });

    let errMsg = `[JsonValidator] validation error. schema='${schemaName}'`;
    console.error(errMsg, schema);
    throw new Error(errMsg + ' ' + errors[0]);
  }
}

export default new JsonValidator();